export default "__VITE_ASSET__D67ZZH8f__"